import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import { Parent } from 'src/app/shared/class/parent.model';
import { AccesosService } from 'src/app/projects/personal/accesos/accesos.service';
import { Result } from 'src/app/shared/class/result.model';
import { UsuarioPersonal } from 'src/app/projects/personal/accesos/accesos-class/accesos.model';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})

export class TopbarComponent extends Parent implements OnInit {
  public nombreUsuario: string = '';
  constructor(
    private authService: AuthService,
    private accesosService: AccesosService,
    private router: Router
  ) { 
    super();
    this.usuario = <UsuarioPersonal>JSON.parse(sessionStorage.getItem('usuario'));
    this.nombreUsuario = <string>JSON.parse(sessionStorage.getItem('nombreUsuario'));
  }

  ngOnInit() {
  }

  onLogOut(){
    /* this.authService.logout(); */
    window.location.href = '/login';
    localStorage.clear();
    sessionStorage.clear();
  }

  cambiarPassword() {
    Swal.fire({
      title: 'INGRESAR NUEVO PASSWORD',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'GUARDAR PASSWORD',
      cancelButtonText: 'CANCELAR',
      showLoaderOnConfirm: true,
      preConfirm: (password) => {
        this.usuario.contrasenia = password;
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        this.showProcessing = true;
        this.accesosService.cambiarPassword(this.usuario.uid, this.usuario.contrasenia)
          .subscribe((result: Result) => {
            if (result.success) {
              this.mensajePopup.alertaValidacion(true, 'OK', 'Se guardó correctamente el password');
              this.onLogOut();
            }
            this.showProcessing = false;
          });
      }
    })
  }
}
